<template>
  <div class="d-flex align-items-center">
    <label class="mb-0 mr-1 text-nowrap">Attachment</label>
    <b-form-select
      :value="value"
      :options="options"
      class="w-auto"
      @change="$emit('input', $event)"
    />
  </div>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue'

export default {
  components: { BFormSelect },
  props: {
    value: { type: String, default: 'all' },
  },
  data() {
    return {
      options: [
        { value: 'all', text: 'All' },
        { value: 'missing', text: 'Missing files' },
        { value: 'complete', text: 'No missing files' },
      ],
    }
  },
}
</script>
